const HomeGridReveal = (): void => {
  const grid = document.querySelector<HTMLElement>(".home-podcast-grid");
  if (!grid) {
    return;
  }

  const cards = Array.from(grid.querySelectorAll<HTMLElement>(".home-podcast-card"));
  if (cards.length === 0) {
    return;
  }

  const columnsFromViewport = (): number => {
    const width = window.innerWidth;
    if (width >= 1400) {
      return 4;
    }
    if (width >= 980) {
      return 3;
    }
    if (width >= 640) {
      return 2;
    }
    return 1;
  };

  const valueFromSeed = (seed: number, min: number, max: number): number => min + (max - min) * seed;

  const overlapFromSeed = (columns: number, column: number, seed: number): number => {
    if (columns === 2) {
      return column === 1 ? -valueFromSeed(seed, 10, 14) : 0;
    }
    if (columns === 3) {
      if (column === 1) {
        return -valueFromSeed(seed, 7, 10);
      }
      if (column === 2) {
        return -valueFromSeed(seed, 14, 18);
      }
      return 0;
    }
    if (columns >= 4) {
      if (column === 1) {
        return -valueFromSeed(seed, 5, 8);
      }
      if (column === 2) {
        return -valueFromSeed(seed, 10, 14);
      }
      if (column === 3) {
        return -valueFromSeed(seed, 17, 23);
      }
      return 0;
    }
    return 0;
  };

  cards.forEach((card) => {
    card.dataset.overlapSeed = Math.random().toString();
    card.dataset.scaleSeed = Math.random().toString();
  });

  const applyRandomCardLayout = (): void => {
    const columns = columnsFromViewport();

    cards.forEach((card, index) => {
      const overlapSeed = Number(card.dataset.overlapSeed ?? "0.5");
      const scaleSeed = Number(card.dataset.scaleSeed ?? "0.5");
      const columnIndex = columns > 1 ? index % columns : 0;

      const overlapX = overlapFromSeed(columns, columnIndex, overlapSeed);
      const scale = valueFromSeed(scaleSeed, 0.86, 1.14) * 1.05;

      card.style.setProperty("--card-overlap-x", `${overlapX.toFixed(2)}%`);
      card.style.setProperty("--card-scale", scale.toFixed(3));
      card.style.setProperty("--reveal-delay", `${columnIndex * 45}ms`);
    });
  };

  applyRandomCardLayout();

  let resizeFrame: number | null = null;
  window.addEventListener("resize", () => {
    if (resizeFrame !== null) {
      window.cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = window.requestAnimationFrame(() => {
      applyRandomCardLayout();
      resizeFrame = null;
    });
  });

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReducedMotion || !("IntersectionObserver" in window)) {
    cards.forEach((card) => card.classList.add("is-visible"));
    return;
  }

  document.body.classList.add("home-grid-enhanced");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        const card = entry.target as HTMLElement;
        card.classList.add("is-visible");
        observer.unobserve(card);
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.06,
    },
  );

  cards.forEach((card) => observer.observe(card));
};

export default HomeGridReveal;
